import React, { useState } from 'react';
import { login } from './api';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const data = await login(username, password);
            localStorage.setItem('token', data.token);
            window.location.href = '/admin';
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
            <div className="card p-4">
                <h3>Admin Login</h3>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <input placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                        <input placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-control" />
                    </div>
                    <button className="btn btn-primary" type="submit">Login</button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
